export const forbiddenListNames = [
  'NOT STARTED',
  'IN PROGRESS',
  'COMPLETED',
  'ON HOLD',
  'FOR REVIEW',
  'FUTURE ACTIONS',
  'PERSONAL NOTES'
]
